import { createAiEmployeeConsoleApi } from './ai-employee-console'

export default createAiEmployeeConsoleApi('/newAiEmployee')
